import React from 'react';
import { branch, renderComponent } from 'recompose';

import { containerApp } from '../../main';

const Spinner = () => (
  <div className="u-text-center">
    <div className="u-inline-block">
      <div className="c-loader__spin" data-automation-id="icon:loading" />
    </div>
  </div>
);

export default branch(
  props => props.showForContainerApp,
  renderComponent(Spinner),
)(containerApp.hideForContainerApp(Spinner));
